import axios from 'axios'
import {
	Message,
	MessageBox
} from 'element-ui';
// // 正式用
const http = axios.create({
	baseURL: process.env.NODE_ENV === 'development' ? "/api" : "http://admin.shengqianyunbbs.com/admin",
	timeout: 30000
})
// //测试用
// const http = axios.create({	
// 	baseURL: process.env.NODE_ENV === 'development' ? "/api" : "http://192.168.101.235/admin",
// 	timeout: 9900
// })
let token = sessionStorage.getItem('token')	
http.interceptors.request.use(function(config) {
	// 检查是否有token如果没有退出
	if (sessionStorage.getItem('token')) {
		// config.headers.token = token;
		config.headers.common["token"] = sessionStorage.getItem('token');
	}
	return config;
}, function(error) {
	// 对请求错误做些什么
	return Promise.reject(error);
});

// 添加响应拦截器
http.interceptors.response.use(function(response) {
	
	if (response.config.responseType === 'blob') return response;
	// 对响应数据做点什么
	if (response.data.code != 0) {
		if (response.data.code == '60105' || response.data.code == '60104') {
			Message({
				message: '登录状态过期,请从新登录',
				type: 'warning'
			})
			sessionStorage.removeItem('token')
			location.href = '/'
		} else {
			Message({
				message: response.data.message,
				type: 'warning'
			});
		}
		return Promise.reject(response.message);
	}
	return response;
}, function(error) {
	// 对响应错误做点什么
	return Promise.reject(error);
});
export default {
	http: http,
	get: function(url, data, callbackFn, catchFn) {
		let datas = data;
		if (typeof data === 'function') {
			callbackFn = data
			datas = {}
		}
		http.get(url, {
			params: datas
		}).then((res) => {

			callbackFn && callbackFn(res.data)
		}).catch((err) => {
			catchFn && catchFn(err)

		})
	},
	post: function(url, data, callbackFn) {
		let datas = data;
		if (typeof data === 'function') {
			callbackFn = data
			datas = {}

		}
		// x-www-form-urlencoded
		http.post(url, datas, {headers: {'content-type':"application/json"}}).then((res) => {
			callbackFn && callbackFn(res.data)
		}).catch((err) => {
			console.log(err)
		})
	},
	put: function(url, data, callbackFn) {
		let datas = data;
		if (typeof data === 'function') {
			callbackFn = data
			datas = {}
		}
		http.put(url, datas).then((res) => {
			callbackFn && callbackFn(res.data)
		}).catch((err) => {
			console.log(err)
		})
	},
	delete: function(url, data, callbackFn, catchFn) {
		let datas = data;
		if (typeof data === 'function') {
			callbackFn = data
			datas = {}
		}
		http.delete(url, {
			params: datas
		}).then((res) => {

			callbackFn && callbackFn(res.data)
		}).catch((err) => {
			catchFn && catchFn(err)

		})
	},
	getExport: function(url, data, callbackFn, catchFn) {
		let datas = data;
		if (typeof data === 'function') {
			callbackFn = data
			datas = {}
		}
		http({
			url,
			method: 'POST',
			data: datas,
			responseType: 'blob'
		}).then((res) => {
			var blob = new Blob([res.data], {
				type: "application/vnd.ms-excel;charset=UTF-8"
			});
			var objectUrl = URL.createObjectURL(blob);
			var a = document.createElement('a');
			a.href = objectUrl;
			//导出文件名
			var fileName = new Date().getTime();
			a.download = "数据表格-" + fileName + ".xls";
			a.target = '_blank';
			a.click();
			callbackFn && callbackFn(res)
		}).catch((err) => {
			catchFn && catchFn(err)

		})
	},
}
